import React, { useState, useLayoutEffect, useRef, useEffect } from "react";
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import ContactPage from "./Contact";
import About2Page from "./About2";
import ProjectsPage from "./projects";
import IntroTerminal from "../components/IntroTerminal";
import MobileBack from "../components/MobileBack";
import zIndex from "@mui/material/styles/zIndex";
import { PointerHost } from "@testing-library/user-event/dist/cjs/system/pointer/index.js";
import { duration, radioGroupClasses } from "@mui/material";
import { easeIn, motion } from 'framer-motion';

const MobileHome =({page}) =>{
    function scrollToInstantMobile(name){
        if(name != null){
        var element = document.getElementById(name);
        var container = document.getElementById("sectionContainerMobile");
        if((element != null) && (container != null)){
            // element.scrollIntoView({ behavior: "smooth" });
            container.scrollTo({
                top: element.offsetTop - 100,
                behavior: "instant"
            });
        }
    }
}
    const pageVariants = {
        open:{
            opacity: 1,
            transition:{
                delay: 0.1,
                duration: 0.5,
                ease: "easeInOut"
            }
        },
        closed:{
            opacity: 0,
            transition:{
                delay: 0.5,
            }
        }
    }
    const terminalVariants = {
        open:{
            transition:{
                delay: 0.2,
                duration: 0.5,
                ease: "easeInOut"
            }
        },
        closed:{
            transition:{
                delay: 0.5,
            }
        }
    }
    const page0 = useRef();
    const page1 = useRef();
    const page2 = useRef();
    const page3 = useRef();
    
    useEffect(() => {
        if(page0.current && page1.current && page2.current && page3.current){
        const p0Observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if(entry.isIntersecting){
          setOnpage0(true)
          setCurrPage(0)
        }else{
          setOnpage0(false)
        }
        });
        p0Observer.observe(page0.current);

        const p1Observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if(entry.isIntersecting){
          setOnpage1(true)
          setCurrPage(1)
        }else{
          setOnpage1(false)
        }
        });
        p1Observer.observe(page1.current);

        const p2Observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if(entry.isIntersecting){
          setOnpage2(true)
          setCurrPage(2)
        }else{
          setOnpage2(false)
        }
        });
        p2Observer.observe(page2.current);

        const p3Observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
         if(entry.isIntersecting){
          setOnpage3(true)
          setCurrPage(3)
        }else{
          setOnpage3(false)
        }
        });
        p3Observer.observe(page3.current);
    }
    }, [])

    const [width, setWidth] = useState(1);
    const [height, setHeight] = useState(1);
    const [currPage, setCurrPage] = useState(0);
    const [currPageName, setCurrPageName] = useState("home");
    const [onpage0, setOnpage0] = useState(false);
    const [onpage1, setOnpage1] = useState(false);
    const [onpage2, setOnpage2] = useState(false);
    const [onpage3, setOnpage3] = useState(false);
    useEffect(() => {
        if(currPage >= 0){
            setOnpage0(true)
        }else{
            setOnpage0(false)
        }
        if(currPage >= 1){
            setOnpage1(true)
        }else{
            setOnpage1(false)
        }
        if(currPage >= 2){
            setOnpage2(true)
        }else{
            setOnpage2(false)
        }
        if(currPage >= 3){
            setOnpage3(true)
        }else{
            setOnpage3(false)
        }
    },[currPage])
    useLayoutEffect(() => {
        const handleResize = () => {
            if(window != null){
                var height = window.innerHeight;
                var width = window.innerWidth;
                setWidth(width);
                setHeight(height);
            }
        };
        handleResize();
        // window.addEventListener("resize", handleResize);
        return () => {
            if(window != null){
                // window.removeEventListener("resize", handleResize)
            }
        };
    }, []);
    useEffect(() => {
        if(page != null){
            scrollToInstantMobile(page);
        }
    },[page, height])
    return(
        <div style={{background: ''}}>
            {/* <Header opacity={1} ease={null} currentPage={0} scrollButtonCallback={() => {}} waveTransforms={[]} headerHeight={'100%'} topOfPage={0} ulTop={0} terminalTop={0} progresBarWidth={0}/>    */}
            <div id="sectionContainerMobile" style={{overflowY: 'scroll', overflowX: 'hidden', height: `${height}px`, width: '100%', position: 'absolute'}} className="sectionContainerMobile">
                <MobileBack scrollPerc={0} width={width} height={height}/>
                <div style={{height: '100px'}}/>
                <div id='home' style={{width: '100%', height: `${height}px`, background: '', alignItems: 'center', justifyContent: 'center'}}>
                    <motion.div variants={pageVariants}
                    initial={'closed'} animate={onpage0 ? "open" : "closed"} 
                    style={{position: 'relative', width: '100%', height: '100%'}}>
                        <IntroTerminal isMobile={true} onPage={onpage0}/>
                    </motion.div>
                        <div ref={page0} style={{position: 'absolute', width: '100%', height: '100px', background: '', top: '150px', pointerEvents: 'none'}}/>
                </div>
                <div id='skills' style={{position: 'relative', width: '100%', height: `${height}px`, background: ''}}>
                    <motion.div variants={pageVariants}
                    initial={'closed'} animate={onpage1 ? "open" : "closed"} 
                    style={{position: 'relative', width: '100%', height: '100%'}}>
                    <About2Page currentPage={currPage} isMobile={true} mobileOnPage={onpage1}/>
                    </motion.div>
                    <div ref={page1} style={{position: 'absolute', width: '100%', height: '100px', background: '', top: '150px', pointerEvents: 'none'}}/>
                </div>
                <div id='projects' style={{position: 'relative', width: '100%', height: `${height}px`, background: ''}}>
                    <motion.div variants={pageVariants}
                    initial={'closed'} animate={onpage2 ? "open" : "closed"} 
                    style={{position: 'relative', width: '100%', height: '100%'}}>
                    <ProjectsPage isMobile={true} mobileOnPage={onpage2}/>
                    </motion.div>
                    <div ref={page2} style={{position: 'absolute', width: '100%', height: '100px', background: '', top: '150px', pointerEvents: 'none'}}/>
                </div>
                <div id='contact' style={{position: 'relative', width: '100%', height: `${height - 100}px`, background: ''}}>
                    <motion.div variants={pageVariants}
                    initial={'closed'} animate={onpage3 ? "open" : "closed"} 
                    style={{position: 'relative', width: '100%', height: '100%'}}>
                    <ContactPage isMobile={true} onPage = {onpage3}/>
                    </motion.div>
                    <div ref={page3} style={{position: 'absolute', width: '100%', height: '100px', background: '', top: '150px', pointerEvents: 'none'}}/>
                </div>
            </div>
            <MobileHeader waveTransforms={[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]} ease={true} style={{overflowX: 'visible', overflowY: 'visible', position: 'absolute', PointerEvent: 'none'}}/>
       </div>
    )
}

export default MobileHome;